
interface ProductBadgeProps {
  type: 'unique' | 'nouveau' | 'stock';
  children: React.ReactNode;
  className?: string;
}

/**
 * Composant centralisé pour les badges produits
 * Utilise la charte graphique harmonisée (rose poudré + beige)
 * 
 * IMPORTANT: Le badge "Avant-première" a été supprimé définitivement
 */
export default function ProductBadge({ type, children, className = '' }: ProductBadgeProps) {
  const getStyles = () => {
    switch (type) {
      case 'unique':
        return 'bg-brand-rose-400 text-white border-brand-rose-500';
      case 'nouveau':
        return 'bg-brand-beige-400 text-brand-text-primary border-brand-beige-500';
      case 'stock':
        return 'bg-brand-beige-200 text-brand-text-secondary border-brand-beige-300';
      default:
        return 'bg-brand-beige-300 text-brand-text-primary border-brand-beige-400';
    }
  };

  return (
    <div className={`
      inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium border-2 shadow-sm
      ${getStyles()} ${className}
    `}>
      {children}
    </div>
  );
}
